import { render } from "./CatFacts.vue?vue&type=template&id=e813b3e0&scoped=true"
import script from "./CatFacts.vue?vue&type=script&lang=js"
export * from "./CatFacts.vue?vue&type=script&lang=js"

import "./CatFacts.vue?vue&type=style&index=0&id=e813b3e0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e813b3e0"]])

export default __exports__